<template>
  <div>
    <div class="row justify-content-center display-grid">
      <span class="strong"> {{ $t('topuptxt') }} </span>
      <fg-input style="width: 25rem;"
        v-model="amountToDeposit"
        type="number"
        :min="0"
        controls-position="right"
        size="large"
        @keyup="calcTaxes"
      >
      </fg-input>
    </div>
    <div class="row justify-content-center mb-3">
      <div class="col-md-12 alert alert-info">
        <span style="width: 30rem; !important;"> {{ feeTxt }} </span>
      </div>
    </div>
    <div class="row justify-content-center display-grid">
      <span class="strong"> {{ $t('amount_charged') }} </span>
      <el-input
        style="width: 25rem;"
        v-model="amountCharged"
        disabled
        class="bigger-symbol text-center">
        <template #prepend>{{ selectedCurrency.toUpperCase() }}</template>
      </el-input>
    </div>
    <br>
    <div class="row justify-content-center display-grid mt-3">
      <p-button wide type="success"
                v-loading="loading"
                :disabled="!exchangeRate"
                v-on:click.prevent="submit">
        {{ $t('submit') }}
      </p-button>
    </div>
  </div>
</template>
<script>
import Constants from "@/assets/constants";
import {Input} from "element-ui";

const rules = Constants.methods.getRules();
const user_data = JSON.parse(localStorage.getItem('user-info'));

const smIntegrationConfig = Constants.methods.smIntegrationConf();
const cpIntegrationConfig = Constants.methods.cpIntegrationConf();
export default {
  name: "srMoneyMethod",
    components: {
    [Input.name]: Input,
  },
  props: {
    selectedCurrency: {type: String, default: '$'}
  },
  computed: {
    feeTxt: {
      get()  {
         return this.$t('paysfixedfee') + ": $" +  this.fixedFee + " + " +
           this.$t('variablefee') + ": " +  this.percentFee + "% * " +
           this.$t('helper_excentry') + ": $"+ this.exchangeRate
      }
    },
  },
  data() {
    return {
      amountToDeposit: 0,
      amountCharged: 0,
      model: {},
      defaultModel: {
        type: 'deposit',
        method: {},
        value: 0,
        exchange_rate: 0,
        charge: 0,
        userid: user_data.email,
        integration_data: {},
        order: {},
      },
      smMethod: [],
      fixedFee: 0,
      percentFee: 0,
      exchangeRate: 1.0000,
      loading: false
    }
  },
  methods: {
    async calcTaxes() {
      this.amountCharged = parseFloat(
        (this.amountToDeposit * this.exchangeRate) +
        (
          this.fixedFee * this.exchangeRate + this.amountToDeposit * this.percentFee / 100 * this.exchangeRate
        )
      ).toFixed(2)
    },
    async submit() {
      this.model.value = this.amountToDeposit
      this.model.charge = this.amountCharged
      this.model.exchange_rate = this.exchangeRate
      await this.handleSrMoneyAuth();
    },
    async handleSrMoneyAuth() {
      this.loading = true;
      const authPayload = {
        response_type: 'code',
        client_id: smIntegrationConfig.cid,
        state: new Date().getTime(),
      };
      window.onmessage = async (event) => {
        if (!event.data || (event.source !== authWin)) {
          return;
        }
        const code = event.data;
        console.log(code)
        if (!code) {
          this.$toast.warning(this.$t('operation_not_authorized'));
        } else {
          this.model.integration_data.code = code;
          await this.submitOrder();
        }
        window.onmessage = undefined;
        this.loading = false;
      }
      const authWin = this.$openPopUp(
          `${smIntegrationConfig.url}/oauthSM/authorize?${this.$serializeToQueryString(authPayload)}`,
          1024,
          720
      );
      let timer = setInterval(() => {
        if (authWin.closed) {
          clearInterval(timer);
          if (!this.model.integration_data.code) {
            this.$toast.warning(this.$t('operation_not_authorized'));
            window.onmessage = undefined;
            this.loading = false;
          }
        }
      }, 1000);
    },
    async submitOrder() {
      this.loading = true;
      const response = await this.$createWalletOrder({
        ...this.model,
        method_id: this.model.method.id,
        integration_data: JSON.stringify(this.model.integration_data),
      }).then(response => {
        if (!this.$validateResponse(response)) {
          return;
        }
        this.model.order = response.data;
        this.tran_id = this.model.order.transaction_id
        this.loading = false;
        this.navigateToOrder();
      }).catch(err => {
        this.$validateResponse(err.data);
        this.loading = false;
      });
    },
    navigateToOrder() {
      this.$router.push({name: 'wallet_order_title', params: {order: this.model.order}});
    }
  },
  async created() {
    let methodList = (await this.$getWalletMethods()).data || [];
    this.smMethod = methodList.find( el => el.value == 'sm' )
    this.fixedFee = this.smMethod.fixed_fee || 0
    this.percentFee = this.smMethod.percent_fee || 0
    this.model = {...this.defaultModel};
    this.model.method = this.smMethod
  }
}
</script>
<style scoped>

</style>
